import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, FieldLabel, Tooltip } from '@systemeio/ui';
import { DateSpecificAvailabilitySlots } from 'modules/calendar/availability/components/date-specific-availability-slots';
import { WeekdaysAvailabilitySlots } from 'modules/calendar/availability/components/weekdays-availability-slots';
import { useDraftAvailabilitySlots } from 'modules/calendar/availability/hooks/use-draft-availability-slots';
import { AvailabilitySlot } from 'modules/calendar/availability/types/availability-interface';
import { groupAvailabilities } from 'modules/calendar/availability/utils';
import { useEffect } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EventAvailabilityProps {
  useGlobalAvailability: boolean;
  onSelectGlobalAvailability: (value: boolean) => void;
  defaultSlots?: AvailabilitySlot[];
  globalSlots?: AvailabilitySlot[];
  onChange: (updatedSlots: AvailabilitySlot[]) => void;
  checkboxError?: string;
  error?: string;
  isLoading?: boolean;
  minDate?: Date;
  maxDate?: Date;
}
export function EventAvailability(t0) {
  const $ = _c(45);
  const {
    useGlobalAvailability,
    onSelectGlobalAvailability,
    defaultSlots,
    globalSlots: t1,
    onChange,
    checkboxError,
    error,
    isLoading,
    minDate,
    maxDate
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const globalSlots = t2;
  const {
    t
  } = useLocoTranslation();
  const {
    draftAvailabilitySlots,
    weekdaysSlots,
    dateSpecificSlots,
    addSlot,
    removeSlots,
    updateSlot
  } = useDraftAvailabilitySlots(defaultSlots);
  let t3;
  if ($[2] !== globalSlots) {
    t3 = groupAvailabilities(globalSlots);
    $[2] = globalSlots;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const globalAvailability = t3;
  let t4;
  if ($[4] !== draftAvailabilitySlots || $[5] !== onChange) {
    t4 = () => {
      onChange(draftAvailabilitySlots);
    };
    $[4] = draftAvailabilitySlots;
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== draftAvailabilitySlots) {
    t5 = [draftAvailabilitySlots];
    $[7] = draftAvailabilitySlots;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== t) {
    t6 = t("dashboard.calendar.available_hours");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <FieldLabel labelClassName="mb-2" label={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== checkboxError || $[14] !== globalSlots?.length || $[15] !== onSelectGlobalAvailability || $[16] !== t || $[17] !== useGlobalAvailability) {
    t8 = checkboxError ? <Tooltip label={checkboxError} mode="hover"><CheckBoxSwitcher label={t("dashboard.calendar.use_global_availability")} selected={useGlobalAvailability} onChange={onSelectGlobalAvailability} disabled={!globalSlots?.length} /></Tooltip> : <CheckBoxSwitcher label={t("dashboard.calendar.use_global_availability")} selected={useGlobalAvailability} onChange={onSelectGlobalAvailability} disabled={!globalSlots?.length} />;
    $[13] = checkboxError;
    $[14] = globalSlots?.length;
    $[15] = onSelectGlobalAvailability;
    $[16] = t;
    $[17] = useGlobalAvailability;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = useGlobalAvailability ? globalAvailability.weekdaysSlots : weekdaysSlots;
  let t10;
  if ($[19] !== addSlot || $[20] !== isLoading || $[21] !== removeSlots || $[22] !== t9 || $[23] !== updateSlot || $[24] !== useGlobalAvailability) {
    t10 = <div className="mb-10 flex-1 md:pr-10"><WeekdaysAvailabilitySlots slots={t9} addSlot={addSlot} removeSlots={removeSlots} updateSlot={updateSlot} disabled={useGlobalAvailability} isLoading={isLoading} titleClassName="text-lg text-text-primary" /></div>;
    $[19] = addSlot;
    $[20] = isLoading;
    $[21] = removeSlots;
    $[22] = t9;
    $[23] = updateSlot;
    $[24] = useGlobalAvailability;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = useGlobalAvailability ? globalAvailability.dateSpecificSlots : dateSpecificSlots;
  let t12;
  if ($[26] !== addSlot || $[27] !== isLoading || $[28] !== maxDate || $[29] !== minDate || $[30] !== removeSlots || $[31] !== t11 || $[32] !== updateSlot || $[33] !== useGlobalAvailability) {
    t12 = <div className="border-text-secondary/30 flex-1 xl:md:border-l xl:md:pl-10"><DateSpecificAvailabilitySlots slots={t11} addSlot={addSlot} removeSlots={removeSlots} updateSlot={updateSlot} disabled={useGlobalAvailability} isLoading={isLoading} minDate={minDate} maxDate={maxDate} titleClassName="text-lg text-text-primary" /></div>;
    $[26] = addSlot;
    $[27] = isLoading;
    $[28] = maxDate;
    $[29] = minDate;
    $[30] = removeSlots;
    $[31] = t11;
    $[32] = updateSlot;
    $[33] = useGlobalAvailability;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t10 || $[36] !== t12) {
    t13 = <div className="mt-8 flex w-full flex-col xl:flex-row">{t10}{t12}</div>;
    $[35] = t10;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== error) {
    t14 = <FieldErrorAndDescription error={error} />;
    $[38] = error;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t13 || $[41] !== t14 || $[42] !== t7 || $[43] !== t8) {
    t15 = <div>{t7}{t8}{t13}{t14}</div>;
    $[40] = t13;
    $[41] = t14;
    $[42] = t7;
    $[43] = t8;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  return t15;
}